<template>
    <div class="row">
        <div class="col-sm-6 col-md-6 col-lg-6 col-xxxl-4 mb-25" v-for="center in enabledCenters" :key="center.id">
            <PatientCenterCard :center="center"/>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import stateStore from "@/utils/store";
import PatientCenterCard from "@/components/FK/Profile/ProfileCenterCard.vue";
import { CenterWithPermission } from '@/utils/models/user.model';

export default defineComponent({
    name: "ProfileCenters",
    data: function() {
        return {
            centers: stateStore.centers()
        } as {
            centers: CenterWithPermission[]
        }
    },
    computed: {
        enabledCenters():CenterWithPermission[] {
            return this.centers.filter((center) => this.showCenter(center.id) && !center.is_custom_center);
        }
    },
    methods: {
        showCenter(center_id: number): boolean {
            return stateStore.getCenterPermission(center_id, 'index') || stateStore.getCenterPermission(center_id, 'show') || stateStore.getCenterPermission(center_id, 'store') || stateStore.getCenterPermission(center_id, 'update') || stateStore.getCenterPermission(center_id, 'destroy');  
        }
    },
    components: {
        PatientCenterCard
    }
})
</script>